import React, { useState } from 'react'
import Select from "react-select"
import moment from "moment"
import { Checkbox, DatePicker, Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../components/reusable/receive'

import { usePet, useQuery, normalize, stringifyDate, useToggle, server, useListData } from '../modules'
import SalesReport from '../components/modals/salesreport'
import ByStaff from '../components/modals/byStaff'
import ByPaymentMethod from '../components/modals/byPaymentMethod'
import EndofDay from '../components/modals/endOfDay'

const { RangePicker } = DatePicker

const Sales = () => {
    const query = useQuery()

    const [string, setString] = useState('')
    const [shft, setShift] = useState()
    const [str, setStr] = useState('')
    const [sales, setSales] = useState([])
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])
    const [categories, setCategories] = useState([])
    const [origins, setOrigins] = useState([])
    const [origin, setOrigin] = useState({ label: 'All Stations', value: 'All' })
    const [category, setCategory] = useState({ label: 'All Categories', value: 'All' })

    const [salesModal, toggleSalesModal] = useToggle()
    const [dateRange, toggleDateRange] = useToggle()
    const [byStaff, toggleByStaff] = useToggle()
    const [byMethod, toggleByMethod] = useToggle()
    const [broad, toggleBroad] = useToggle()
    const [eodModal, toggleEODModal] = useToggle()

    const rangesOK = ranges?.length === 2 && ranges[0] && ranges[1]

    const [
        { loading: sLoading, error: sError, fetch },
        { list: shifts = [] },
    ] = useListData('allShifts', { string: str, department: 'OPD' }, { notify: true }, 'shifts')

    const [{ loading, error, data }, getItemSales] = usePet('salesByItemByRoutingGroup',
        ranges?.length === 2 && rangesOK ? 
            { 
                routingGroup: category?.value,
                origin: origin?.value,
                from: ranges[0]?._d ?? ranges[0], 
                to: ranges[1]?._d ?? ranges[1] 
            }
        : 
        { 
            routingGroup: category?.value,
            origin: origin?.value
        }
    , { notify: true, callback: ({ data }) => setSales(data), manual: !(ranges?.length === 2), manual: ranges?.length !== 2 || !ranges[0] || !ranges[1] })

    const onComplete = ({ data }) => {
        data = data.map(catg => ({ label: catg, value: catg }))
        setCategories([
            { label: 'All Categories', value: 'All' },
            ...data
        ])
    }

    const [{ loading: catsLoading, error: catsError }] = usePet('routingGroupNames', null, { notify: true, callback: onComplete })

    const toggleRange = () => {
        setRanges([moment().startOf('day'), moment().endOf('day')])
        setShift()
        if (!dateRange)
            getItemSales()
        toggleDateRange()
    }

    const search = str => {
        setString(str)
        let temp = data.filter(item => item.name.toLowerCase().indexOf(str.toLowerCase()) >= 0)
        setSales(temp)
    }

    const changeCategory = val => {
        setString('')
        setCategory(val)
        getItemSales()
    }

    const changeStation = val => {
        setString('')
        setOrigin(val)
        getItemSales()
    }

    const toggleBrd = () => {
        toggleBroad()
        changeCategory({ label: 'All Categories', value: 'All' })
    }

    const selectRange = range => {
        range = range ?? [moment(), moment()]

        setString('')
        setRanges(range)
        getItemSales()
    }

    const selectShift = shift => {
        setShift(shift)
        selectRange([moment(shift.start), moment(shift.end ?? new Date())])
    }

    let period = rangesOK && String(ranges[0]) === String(ranges[1]) ? `For ${stringifyDate(ranges[0]?._d, true)}` : `From ${stringifyDate(ranges[0]?._d, true)} To ${stringifyDate(ranges[1]?._d, true)}`

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-between mb-8">
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <input
                        onChange={ e => search(e.target.value) }
                        value={ string }
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                        id="grid-inv-item"
                        type="text"
                        placeholder="Type to search items" />
                </div>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <Checkbox 
                        value={ dateRange } 
                        onChange={ toggleRange }>Use Date Range</Checkbox>
                    {
                        dateRange ?
                            <RangePicker 
                                value={ ranges } 
                                showTime 
                                onChange={selectRange}
                                ranges={{
                                    'Today': [moment().startOf('day'), moment().endOf('day')],
                                    'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                                    'This Week': [moment().startOf('week'), moment().endOf('week')],
                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                }}/>
                        :
                            <Select
                                value={ shft }
                                onChange={ selectShift }
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={ shifts.map(({ _id, user, start, date, end }) => ({
                                    user,
                                    label: `${user.name} (${stringifyDate(date)}${end ? ` - ${stringifyDate(end)}` : '' })`,
                                    value: _id,
                                    date,
                                    start,
                                    end
                                })) }
                                placeholder="Select Shift" />
                    }
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={toggleSalesModal}>By Category</Menu.Item>
                                <Menu.Item onClick={toggleByStaff}>By Staff</Menu.Item>
                                <Menu.Item onClick={toggleByMethod}>By Payment Method</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Sales Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                </div>
            </div>
            {
                salesModal && rangesOK &&
                <SalesReport
                    selectCategory={ cat => {
                        changeCategory(cat)
                        getItemSales()
                    } }
                    ranges={ranges}
                    toggle={toggleSalesModal}
                    visible={salesModal} />
            }
            {
                eodModal && rangesOK &&
                <EndofDay
                    shift={ shft }
                    ranges={ranges}
                    toggle={toggleEODModal}
                    visible={eodModal} />
            }
            {
                byStaff && rangesOK &&
                <ByStaff
                    ranges={ranges}
                    toggle={toggleByStaff}
                    visible={byStaff} />
            }
            {
                byMethod && rangesOK &&
                <ByPaymentMethod
                    ranges={ranges}
                    toggle={toggleByMethod}
                    visible={byMethod} />
            }
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                {
                    rangesOK ?
                        <>
                            <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                                <h2 className="font-semibold mb-0 text-gray-800">Sales for { category?.label } { category?.label && 'Category' } { period }</h2>
                                <div className="grid grid-flow-col sm:auto-cols-max items-center justify-start sm:justify-end gap-2">
                                    <Receive
                                        error={catsError}
                                        loading={catsLoading}
                                        progress>
                                        <Select
                                            value={ category }
                                            onChange={ changeCategory }
                                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                            options={ categories }
                                            placeholder="Category" />
                                    </Receive>
                                    <a className="text-gray-600" rel="noreferrer" target="_blank" href={`${server}/salesReport/${broad ? 'broad/' : '' }${ category?.value }?from=${ranges[0]?._d.toISOString()}&to=${ranges[1]?._d.toISOString()}&origin=${origin?.value}`}>
                                        <button className="btn hisani-btn-green-light ml-2 text-white">
                                            <span className="hidden xs:block px-3">Print</span>
                                        </button>
                                    </a>
                                    {
                                        ((dateRange && rangesOK) || (!dateRange && shft)) &&
                                        <button onClick={ toggleEODModal } className="btn hisani-btn-green-light ml-2 text-white">
                                            <span className="hidden xs:block px-3">{ !shft?.end ? 'End of Day' : 'General Report' }</span>
                                        </button>
                                    }
                                </div>
                            </header>
                            <div className="p-3">

                                {/* Table */}
                                <div className="overflow-x-auto">
                                    <Receive
                                        error={error}
                                        loading={loading}
                                        progress>
                                        {
                                            sales.length > 0 ?
                                                <table className="table-auto w-full">
                                                    {/* Table header */}
                                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                        <tr>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center">No</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Item</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Category</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Quantity Sold</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Discounts Given</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Taxes</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-left">Total Value</div>
                                                            </th>
                                                            <th className="p-2">
                                                                <div className="font-semibold text-center"></div>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    {/* Table body */}
                                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                        {
                                                            sales.map((item, key) =>
                                                                <tr>
                                                                    <td className="p-2">
                                                                        <div className="text-center">{key + 1}.</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{item.name}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{item.category}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">{item.count}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">Ksh. {normalize(item.discount)}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">Ksh. {normalize(item.tax)}</div>
                                                                    </td>
                                                                    <td className="p-2">
                                                                        <div className="">Ksh. {item.sales}</div>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </tbody>
                                                </table>
                                            :
                                                <div className="flex py-10 font-semibold text-md justify-center items-center">
                                                    <h2>No sales have been recorded for { category?.label } { category?.label && 'Category' } { period }</h2>
                                                </div>
                                        }
                                    </Receive>
                                </div>
                            </div>
                        </>
                    :
                        <div className="flex py-10 font-semibold text-md justify-center items-center">
                            <h2>Please select a date range</h2>
                        </div>
                }
            </div>
        </div>
    )
}

export default Sales